import React, { useState, useEffect } from 'react';
import {
	Grid,
	Typography,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Alert,
} from '@mui/material';
import { HeaderSection, setColorStyle } from './BiasInfo';
import { getFullName, whichEvent } from '../../../helpers/utils';
import { formatDateTimeMX } from '../../../helpers/hours';
import { getEvents } from '../../../actions/event';
import Label from '../../utils/Label';

// EVENT LIST
export const History = ({ bias = null }) => {
	const [events, setEvents] = useState([]);

	useEffect(() => {
		if (bias !== null) {
			getEvents(bias.id).then(({ data }) => {
				setEvents(
					data.results.map((item) => ({
						key: item.key,
						title: item.title,
						type: whichEvent(item.type),
						created_by: item.created_by,
						description: item.description,
						created_at: formatDateTimeMX(item.created_at),
					}))
				);
			});
		}
	}, [bias]);

	return (
		<Grid
			item
			xs={4}
			style={{
				...setColorStyle('green'),
				height: '100%',
			}}
		>
			{bias && (
				<Grid
					container
					// spacing={2}
					style={{
						...setColorStyle('red'),
						height: '100%',
					}}
				>
					<Grid
						item
						xs={12}
						style={{
							...setColorStyle('blue'),
							padding: '15px',
						}}
					>
						<HeaderSection text='Historial' />
						<div
							style={{
								margin: '10px 0 0 0',
								maxHeight: '70vh',
								overflow: 'scroll',
								overflowX: 'hidden',
							}}
						>
							<List dense>
								{/* {subbias.annotations.length > 0 ? ( */}

								{events.length > 0 ? (
									<List>
										{events.map((note) => (
											<ListItemNote
												key={note.key}
												note={note}
											/>
										))}
									</List>
								) : (
									<Alert severity='info'>
										No hay eventos
									</Alert>
								)}
							</List>
						</div>

						<hr />
					</Grid>
				</Grid>
			)}
		</Grid>
	);
};

const ListItemNote = ({ note }) => (
	<ListItem alignItems='flex-start' style={{ marging: '10px 0' }}>
		<ListItemAvatar>
			<Label color={note.type.label}>{note.type.text}</Label>{' '}
		</ListItemAvatar>
		<ListItemText
			primary={`[${note.title}]`}
			secondary={
				<React.Fragment>
					<br />{' '}
					<Typography
						sx={{
							display: 'inline',
						}}
						component='span'
						variant='body2'
						color='text.primary'
					>
						{`${getFullName(note.created_by)}`}
					</Typography>
					{` — ${note.description}`}
					<br /> <br /> {note.created_at}
				</React.Fragment>
			}
		/>
	</ListItem>
);
